import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M22.544 14.57 17.5 12.25V9.643a.786.786 0 0 0-.786-.786H4.93V7.68a1.964 1.964 0 1 0-3.929 0v6.678a.786.786 0 0 0 .786.786h.078l4.353-.456 4.212 2.247a11.2 11.2 0 0 0 5.335 1.352 11.4 11.4 0 0 0 6.93-2.357.786.786 0 0 0-.15-1.336zM2.571 7.678a.393.393 0 1 1 .786 0v1.178h-.786zm0 2.75H15.93v1.65L2.57 13.485zm8.596 5.122L9 14.357l7.637-.786 4.007 1.839a9.65 9.65 0 0 1-9.476.141"
    }, null, -1)
  ]))]))
}
export default { render: render }